type FleetViewDivisionDto = {
  DivisaoID?: string | number;
  NomeDivisao?: string;
  QtdFrotas?: string | number;
  NaoAtribuido?: string;
};

type FleetViewGroupDto = {
  GrupoID?: string | number;
  Nome?: string;
  Divisao?: FleetViewDivisionDto[];
};

const mapDivisions = (divisions?: FleetViewDivisionDto[]): Division[] =>
  (divisions || []).map(dto => ({
    divisionId: dto.DivisaoID?.toString() || '',
    divisionName: dto.NomeDivisao || '',
    fleetQtt: dto.QtdFrotas?.toString() || '',
    notAssigned: dto.NaoAtribuido || '',
  }));

export const mapFleetViews = (payload: unknown): Group[] => {
  const groups = Array.isArray(payload)
    ? (payload as FleetViewGroupDto[])
    : [];

  return groups.map(dto => ({
    groupId: dto.GrupoID?.toString() || '',
    groupName: dto.Nome || '',
    groupDivision: mapDivisions(dto.Divisao),
  }));
};
